import { render } from "./PickingData.vue?vue&type=template&id=11d4cf48"
import script from "./PickingData.vue?vue&type=script&lang=js"
export * from "./PickingData.vue?vue&type=script&lang=js"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__